<div class="item-container">
    <div class="item-header">
      <h5 class="text-center" *ngIf="!dialogData.edit">{{"COMMON.ADD" | translate}} {{"COMMON.DEP" | translate}}</h5>
      <h5 class="text-center" *ngIf="dialogData.edit">{{"COMMON.EDIT" | translate}} {{"COMMON.DEP" | translate}}</h5>
      <div class="edit-icons" (click)="onCancel()" mat-dialog-close>
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content" style="position: relative;">
      <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center spinner-overlay" *ngIf="isSpinnerLoading">
        <div class="custom-loader"></div>
      </div>
      <form action="" [formGroup]="depForm" (ngSubmit)="onSubmit()">
          <div class="row">
              <div class="col-12 mt-3 mt-3 mt-lg-4">
                  <label for="">{{"MENUITEMS.DEPARTMENT.DEPNAME"|translate}}</label>
                  <div class="form-input ">
                      <input type="text" class="form-control" placeholder="{{'COMMON.ENTER' | translate}} {{'COMMON.NAME' | translate}}" formControlName="dep">                  
                  </div>
                  <mat-error *ngIf="isControlHasError('dep','required')">  {{"COMMON.THR"|translate}}</mat-error>
              </div>
          </div>
          
         <div class="row">
          <div class="col-md-6 m-auto mt-xl-2">
            <button mat-raised-button   color="primary"  class="auth-form-btn mt-3 mt-lg-4"  type="submit">{{ "BUTTON.SAVE" | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  